export enum Status {
  Error = "Error",
  Loading = "Loading",
  Ready = "Ready",
}
